export enum AlgoliaAnalyticsEvents {
    ClickedObjectIDsAfterSearch = "clickedObjectIDsAfterSearch",
    ClickedObjectIDs = "clickedObjectIDs",

    ViewedObjectIDs = "viewedObjectIDs",

    ClickedFilters = "clickedFilters",

    ProductAddToCartAfterSearch = "addedToCartObjectIDsAfterSearch",
    ProductAddToCartNoSearch = "addedToCartObjectIDs",

    PurchaseAfterSearch = "purchasedObjectIDsAfterSearch",
    PurchaseNoSearch = "purchasedObjectIDs",
}

export enum AlgoliaAnalyticsEventNames {
    ProductAddToCartPDP = "product-addtocart-pdp",
    ProductAddToCartPLP = "product-addtocart-plp",
    Purchase = "purchase",
    PurchaseAfterSearch = "purchase-after-search",
    HitClicked = "Hit Clicked",
    HitsViewed = "Hits Viewed",
    FilterApplied = "Filter Applied"
}
